<div
  *transloco="let t; read: 'change-language'"
  class="xi-modal__container change-language__container"
>
  <h2 class="xi-modal__title">{{ t('set-language') }}</h2>

  <form [formGroup]="form" class="xi-modal__content">
    <xi-dropdown formControlName="code" [stretch]="true" [data]="ds"></xi-dropdown>
  </form>

  <div class="xi-modal__actions change-language__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('set-language')"
      [disabled]="form.invalid"
      (onClick)="onSet()"
    ></xi-default-button>
  </div>
</div>
